<template>
    <div
      class="modal fade createNewModal"
      id="AddElementModal"
      tabindex="-1"
      ref="addElementModalRef"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-15 p-md-40">
          <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
            <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
          </div>
          <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
            <Form ref="elementForm" @submit="addElement" :validation-schema="elementSchema">
                
                <div class="row">

                    <div class="col-md-4">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                        <label class="d-block text-black fw-semibold mb-10">
                        Decodeur <span class="text-danger">*</span>
                        </label>
                        <Field name="numAbonnement" type="text" 
                        disabled="true"
                        class="form-control shadow-none fs-md-15 text-black"/>
                        <ErrorMessage name="numAbonnement" class="text-danger"/>
                    </div>
                    </div>

                    <div class="col-md-4">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                        <label class="d-block text-black fw-semibold mb-10">
                        Type <span class="text-danger">*</span>
                        </label>
                        <Field name="type" type="text" 
                        disabled="true"
                        class="form-control shadow-none fs-md-15 text-black"/>
                        <ErrorMessage name="type" class="text-danger"/>
                    </div>
                    </div>

                    <div class="col-md-3">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                        <label class="d-block text-black fw-semibold mb-10">
                            Date
                        </label>
                        <Field name="nouvelleDateFinAbonnement" type="date"  :value="getCurrentDate()"
                        class="form-control shadow-none fs-md-15 text-black"/>
                        <ErrorMessage name="nouvelleDateFinAboinnement" class="text-danger"/>
                    </div>
                    </div>

                  

                </div>
                
              
              <button
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                type="submit">
                {{ btntext }}
              </button>
          </Form>
          </div>
          <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="resetValue()"
          ></button>
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref, watch, onMounted } from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import ApiService from '../../services/ApiService';
  import * as Yup from 'yup';
  import { error , success, hideModal } from '../../utils/utils';
  import Multiselect from '@vueform/multiselect';
  import { Demande } from '@/models/Demande';
  
  export default defineComponent({
      name: "ValiderDemande",
      components: {
      Form,
      Field,
      ErrorMessage,
    //   Multiselect
    },
    props: {
      item: {
        type: Number,
        default: 0,
      }
    },
    setup(props, { emit }){
      const elementSchema = Yup.object().shape({
        numAbonnement: Yup.string().required('Le libelle est obligatoire'),
        type: Yup.string().required('Le type est obligatoire'),
        nouvelleDateFinAbonnement: Yup.date().required('La date est obligatoire'),
      });
  
      
      const elementForm = ref<Demande | null>(null);
      const addElementModalRef = ref<null | HTMLElement>(null);
      const categorieSelected = ref(null);
      const typeRemiseSelected = ref(null);
      const typeActualiteSelected = ref(null);
      const categorieOptions = ref([]);
      
      const isUPDATE = ref(false);
      const title = ref("Ajouter une actualité");
      const btntext = ref('Enregistrer');
  
      watch(() => props.item, (newValue) => {
        getOne(newValue);
        isUPDATE.value = true;
        btnTitle();
      });
  
      const btnTitle = async () => {
        if (isUPDATE.value) {
           title.value = "Modifier l'actualité";
           btntext.value = "Modifier";
        }else{
           title.value = "Ajouter une actualité";
           btntext.value = "Enregistrer";
        }
      } 
  
  
     
      const getOne = async (id: number) => {
        return ApiService.get("/demande/"+id)
        .then(({ data }) => {
          // map data in form
          const donnees = data.data;
          // const categories = donnees.categories;
  
          // let ids: number[] = [];
          // for (const categorie of categories) {
          //   ids.push(categorie.id); 
          // }
          // categories.value= ids;
  
          // defaultSelectedCategories.value = categories.value
          for (const key in donnees) {
            elementForm.value?.setFieldValue(key, 
            (typeof donnees[key] === 'object' && donnees[key] !== null)? donnees[key].id :donnees[key]
            );
          }
          emit('openmodal', addElementModalRef.value);
  
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
      }

  
      const addElement = async (values: any, elementForm) => {
        
        values = values as Demande;
        // values['etat'] = "Traitée";
       
        ApiService.put("/demande/"+values.id,values)
        .then(({ data }) => {
            if(data.code == 200) { 
            success(data.message);
            elementForm.resetForm();
            hideModal(addElementModalRef.value);
            isUPDATE.value=false;
            btnTitle();
            emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });

      };
     
  
    //   onMounted(() => {
    //     // fetchFormules();
    //     //
    //   });

        const getCurrentDate = () => {
                const today = new Date();
                const day = String(today.getDate()).padStart(2, '0');
                const month = String(today.getMonth() + 1).padStart(2, '0');
                const year = today.getFullYear();
                return `${year}-${month}-${day}`;
        }
  
      const resetValue = () => {
        const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
          isUPDATE.value=false;
        formFields.forEach(field => {
          field.value = '';
        });
        btnTitle()
      };
  
      return { 
        elementSchema,
        addElementModalRef,
        addElement,
        elementForm,
        title,btntext,
        resetValue,
        typeRemiseSelected,
        typeActualiteSelected,
        getCurrentDate
      };
    },
  });
  </script>